(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["a11y-video-controls"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('a11y-video-controls')) {
    class A11yVideoControls extends HTMLElement {
      connectedCallback() {
        const scope = document.getElementById(this.dataset.scope) || this.parentElement;
        this.videos = scope ? Array.from(scope.querySelectorAll('video')) : [];
        if (!this.videos.length) return;

        this.button = this.querySelector('.a11y-video-controls__button');
        this.iconPause = this.querySelector('.a11y-video-controls__icon--pause');
        this.iconPlay = this.querySelector('.a11y-video-controls__icon--play');
        this.update = this.update.bind(this);

        this.videos.forEach((video) => {
          this.describe(video);
          this.addCaptions(video);
          video.addEventListener('play', this.update);
          video.addEventListener('pause', this.update);
        });

        const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduceMotion) {
          this.videos.forEach((video) => {
            video.removeAttribute('autoplay');
            video.autoplay = false;
            video.dataset.userPaused = 'true';
            video.pause();
          });
        }

        if (this.button) this.button.addEventListener('click', () => this.toggle());
        this.update();
      }

      describe(video) {
        const label = this.dataset.videoLabel;
        if (label) {
          video.setAttribute('aria-label', label);
          video.removeAttribute('aria-hidden');
        } else if (!video.hasAttribute('controls') && !video.hasAttribute('aria-label')) {
          // Decorative, muted background loop: hide from assistive tech (the visible toggle stays reachable).
          video.setAttribute('aria-hidden', 'true');
          video.setAttribute('tabindex', '-1');
        }
      }

      addCaptions(video) {
        const src = this.dataset.captionsSrc;
        if (!src || video.querySelector('track[kind="captions"]')) return;
        const track = document.createElement('track');
        track.kind = 'captions';
        track.src = src;
        track.srclang = this.dataset.captionsLang || 'en';
        track.label = this.dataset.captionsLabel || 'English';
        track.default = true;
        const wasPlaying = !video.paused;
        // Only switch to CORS mode for Shopify-hosted video (Shopify CDN sends CORS headers);
        // forcing it on an external host without Access-Control-Allow-Origin would stop the video loading.
        const videoSrc = video.currentSrc || (video.querySelector('source') || {}).src || video.src || '';
        let shopifyHosted = false;
        try {
          const host = new URL(videoSrc, location.href).hostname;
          shopifyHosted = host === location.hostname || /(^|\.)(my)?shopify\.com$/.test(host);
        } catch (e) {}
        if (!video.crossOrigin && shopifyHosted) {
          video.crossOrigin = 'anonymous';
          video.appendChild(track);
          video.load();
          if (wasPlaying) video.play().catch(() => {});
        } else {
          video.appendChild(track);
        }
      }

      isPlaying() {
        return this.videos.some((video) => !video.paused && !video.ended);
      }

      toggle() {
        if (this.isPlaying()) {
          this.videos.forEach((video) => {
            video.dataset.userPaused = 'true';
            video.pause();
          });
        } else {
          this.videos.forEach((video) => {
            video.dataset.userPaused = 'false';
            const promise = video.play();
            if (promise && promise.catch) promise.catch(() => {});
          });
        }
        this.update();
      }

      update() {
        if (!this.button) return;
        const playing = this.isPlaying();
        this.button.setAttribute('aria-label', playing ? this.dataset.labelPause : this.dataset.labelPlay);
        if (this.iconPause) this.iconPause.hidden = !playing;
        if (this.iconPlay) this.iconPlay.hidden = playing;
      }
    }
    customElements.define('a11y-video-controls', A11yVideoControls);
  }
  } catch(e) { console.error(e); }
})();

})();
